import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';

import ReactDOM from 'react-dom';
import _ from 'underscore';

import {ANALYTICS_MODULE, ACTION_CATEGORY} from 'constants/AnalyticsConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import navigateToURL from 'lib/navigateToURL';
import OwnableChoiceTemplate from 'profile/OwnableChoiceTemplate';
import notifications from 'notifications';
import * as analytics from 'analytics/Analytics';
import OwnablePage from 'profile/OwnablePage';

const ownablesMap = {};

class OwnablesManageView extends Backbone.View {
  events() {
    return {
      'click .existing-items a': 'selectOwnableFromList',
      'submit .edit-meta': 'handleSaveSubmit',
      'submit .delete-ownable': 'handleDelete',
    };
  }

  initialize(options) {
    this.currentCollaborators = null;
    this.ownables =
      ownablesMap[this.type] != null
        ? ownablesMap[this.type]
        : // oxlint-disable-next-line no-cond-assign
          (ownablesMap[this.type] = this.constructor.getBootstrappedOwnables());
    this.ownables.comparator = (ownable) => `${ownable.get('owner_handle')}-${ownable.get('name')}`;
    this.listenTo(this.ownables, 'sync', this.renderOwnable);
    this.listenTo(this.ownables, 'add remove change:name', this.renderOwnables);
    ({ownableId: this.ownableId} = options);
    this.currentOwnable = this.ownables.get(this.ownableId);
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
    this.$el.find('.ownable-content').addClass('hidden');
    ReactDOM.unmountComponentAtNode(this.el.querySelector('.react-mount'));
  }

  handleDelete = () => {
    const name = this.currentOwnable.get('name');
    const id = this.currentOwnable.get('api_identifier');
    return this.currentOwnable.destroy().done(() => {
      if (this.type === 'feature-libraries') {
        analytics.track('feature_library', 'deleted', {
          product: ANALYTICS_MODULE.MOLBIO,
          actionCategory: ACTION_CATEGORY.WRITE,
          featureLibraryId: id,
        });
      } else {
        analytics.track('data_management', 'deleted_ownable', {type: this.type, name});
      }
      if (this.ownables.length > 0) {
        this.navigateToOwnable(this.ownables.at(0).id);
      } else {
        this.navigateToOwnable(null);
      }
    });
  };

  handleSaveSubmit = (updates) =>
    this.currentOwnable.save(updates, {patch: true, wait: true}).done(() => {
      if (this.type === 'feature-libraries') {
        analytics.track('feature_library', 'updated', {
          product: ANALYTICS_MODULE.MOLBIO,
          actionCategory: ACTION_CATEGORY.WRITE,
          featureLibraryId: this.currentOwnable.get('api_identifier'),
        });
      } else {
        analytics.track('data_management', 'updated_ownable', {type: this.type});
      }
    });

  createCollaboratorsView(collaborators, {onExport = null} = {}) {
    renderToDOM(
      <OwnablePage
        ownableType={this.modelType}
        ownable={this.currentOwnable.attributes}
        collaborators={collaborators}
        onExport={onExport}
        onRequestSubmit={this.handleSaveSubmit}
        onRequestDelete={this.handleDelete}
      />,
      this.el.querySelector('.react-mount')
    );
  }

  selectOwnableFromList(e) {
    e.preventDefault();
    const id = $(e.currentTarget).data('ownableId');
    this.navigateToOwnable(id);
  }

  navigateToOwnable(ownableId, options) {
    if (window.test_user) {
      return;
    }
    // Assumes ID is last component of URL.
    // eslint-disable-next-line no-restricted-syntax
    const parts = _.initial(window.location.pathname.split('/'));
    parts.push(ownableId != null ? ownableId : '');
    navigateToURL(parts.join('/'), options);
  }

  ownableToHtml(ownable) {
    // oxlint-disable-next-line new-cap
    return OwnableChoiceTemplate(ownable.toJSON());
  }

  renderOwnable() {
    if (this.type === 'feature-libraries') {
      analytics.track('feature_library', 'viewed', {
        product: ANALYTICS_MODULE.MOLBIO,
        actionCategory: ACTION_CATEGORY.READ,
        featureLibraryId: this.currentOwnable.get('api_identifier'),
      });
    } else {
      analytics.track('DATA_MANAGEMENT', 'select_ownable', {type: this.type, id: this.currentOwnable.id});
    }
    this.$el.find('.ownable-content').removeClass('hidden');
    this.createCollaboratorsView([]);
  }

  renderOwnables() {
    const $chooseButton = this.$el.find('.create-new .dropdown-toggle .dropdown-text');
    const $select = this.$el.find('.create-new .existing-items');
    $select.empty();
    if (this.ownables.models.length > 0) {
      $select.prop('disabled', false);
      for (const ownable of Array.from(this.ownables.models)) {
        const $anchor = $('<a>')
          .attr('href', '#')
          .html(this.ownableToHtml(ownable))
          .data('ownableId', ownable.id);
        const $option = $(
          `<li data-test-component="OwnableActionHeader" data-test-element="existingOwnableOption" data-test-key=${ownable.id}>`
        ).append($anchor);
        if (ownable.id === (this.currentOwnable != null ? this.currentOwnable.id : undefined)) {
          $option.addClass('selected');
        }
        $select.append($option);
      }
      if (this.currentOwnable != null) {
        $chooseButton.html(this.ownableToHtml(this.currentOwnable));
      }
      $chooseButton.parent().removeClass('disabled');
    } else {
      $chooseButton.text('No existing items.').parent().addClass('disabled');
    }
  }

  render() {
    // Ideally this happens in the router, but would require re-implementing the already-hacky
    // navigateToOwnable at the router-level.
    if (this.ownableId != null && this.currentOwnable == null) {
      notifications.error('The item you were looking for no longer exists.');
      this.navigateToOwnable(null, {replace: true});
      return this;
    }

    this.renderOwnables();
    if (this.currentOwnable != null) {
      this.renderOwnable();
    } else {
      this.$el.find('.tab-panel').addClass('hide');
    }

    return this;
  }
}

export default OwnablesManageView;
